import React from "react";
import ReactDOM from "react-dom";

import {Provider} from "react-redux";

import {store, persistor} from "./Redux/store";

import {PersistGate} from "redux-persist/integration/react";

import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import Home from "./App";
import Head from "./Head";
import Listen from "./Listen";
import Titles from "./titles";
import Dashboard from "./dashboard";
import Market from "./market";

import * as serviceWorker from "./serviceWorker";

import {BrowserRouter as Router, Switch, Route} from "react-router-dom";

export default function App() {
  return (
    <Router>
      <div>
        <Head />
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/dashboard">
            <Dashboard />
          </Route>
          <Route path="/listen">
            <Listen />
          </Route>
          <Route path="/titles">
            <Titles />
          </Route>
          <Route path="/market">
            <Market />
          </Route>
          <Route path="/" component={Home}>
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

function Apppp() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  );
}

ReactDOM.render(<Apppp />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
